import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {roles, rolesLabelMap} from "../../../../../constants/common.constants";

@Component({
  selector: 'app-non-editable-onboarding-details',
  templateUrl: './non-editable-onboarding-details.component.html',
  styleUrls: ['./non-editable-onboarding-details.component.css']
})
export class NonEditableOnboardingDetailsComponent implements OnInit {
  @Input() userDetails;
  @Output() handleClick = new EventEmitter();
  obQuestions = [];
  protected readonly rolesLabelMap = rolesLabelMap;
  protected readonly roles = roles;

  ngOnInit() {
    this.obQuestions = this.userDetails?.responses;
    this.obQuestions?.map(o => {
      if (o.multiselectOptions?.length === 0) {
        const tempData = o['options']?.find((e) => e['key'] === o['selectedOptionId']);
        o['selectedOptionValue'] = tempData?.value
      } else {
        const tempData = o['options']?.filter((obj) => o.multiselectOptions?.includes(obj.key));
        tempData?.map(o =>
          o['value']
        )
        const tempArray = tempData?.map(o => o['value'])
        o['selectedOptionValue'] = tempArray?.join(' | ')
      }

      return o;
    });
  }

  editOnboardingDetails() {
    this.handleClick.emit(false)
  }

}
